module.exports = __webpack_public_path__ + "static/media/como.b4f41de2.jpg";